import { css } from '@emotion/react';
import { applyFont, media, tokens } from '@domain-group/fe-brary';

export const title = css`
  ${applyFont(tokens.typography.displayLarge)};
  color: ${tokens.colors.primary.medium.default};
  margin-bottom: ${tokens.spacing.l};
`;

export const subTitle = css`
  color: ${tokens.colors.primary.base.default};
`;

export const trustSignals = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${tokens.spacing.m};
  margin-top: ${tokens.spacing.m};

  ${media('>=tablet')} {
    flex-wrap: nowrap;
    gap: ${tokens.spacing.m};
  }
`;

export const trustItem = css`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.xs};
  color: ${tokens.colors.neutral.medium.default};
`;

export const trustItemLabel = css`
  ${applyFont(tokens.typography.caption)};
  color: ${tokens.colors.neutral.medium.default};
`;
